export const Sales = {
    ClueMarketingLandingPage: 'Landing Page',
    NoTimeRangePermissionTip:
        'This account has no data permission for any queryable time range. Please contact the client management team to add it.',
    SelectTimeRangeTip: 'Please select a query time range',
};
